// UMANG multi-govt-service stub. UMANG aggregates EPFO, PMO, NSDL, CBDT
// and ~270 services behind one app. No public read-API; tokens are bound
// to UMANG's own session. We expose a deep-link launcher and a TODO list
// of services Wasiyat will integrate as those services arrive.

import type { ConnectorAdapter, ConnectorMode, ConnectorResult, ConnectorStatus } from './_types.ts';
import { ok, nowIso } from './_types.ts';

export interface UmangServiceTodo {
  readonly code: string;
  readonly title: string;
  readonly umangPath: string; // umang:// deep link
  readonly v11Owner: 'fork-7' | 'fork-9' | 'fork-6' | 'fork-10' | null;
}

export interface UmangSnapshot {
  readonly services: readonly UmangServiceTodo[];
  readonly viewedAt: string;
}

export interface UmangConnectorStatus extends ConnectorStatus {
  readonly id: 'umang-stub';
  readonly servicesCount: number;
}

const SERVICES: UmangServiceTodo[] = [
  { code: 'EPFO', title: 'EPFO · UAN passbook', umangPath: 'umang://app/service/EPFO_UAN', v11Owner: 'fork-6' },
  { code: 'NPS', title: 'NPS Trust · transaction statement', umangPath: 'umang://app/service/NPS', v11Owner: 'fork-6' },
  { code: 'AYUSH', title: 'Ayushman Bharat · PMJAY card', umangPath: 'umang://app/service/PMJAY', v11Owner: 'fork-9' },
  { code: 'NPMS', title: 'National Pension System · contributions', umangPath: 'umang://app/service/NPS_CONTRIB', v11Owner: 'fork-6' },
  { code: 'PMJDY', title: 'PMJDY · Jan Dhan account', umangPath: 'umang://app/service/PMJDY', v11Owner: 'fork-6' },
  { code: 'POST', title: 'India Post · parcel tracker', umangPath: 'umang://app/service/POST_TRACK', v11Owner: null },
];

export class UmangStubAdapter
  implements ConnectorAdapter<UmangConnectorStatus, UmangSnapshot>
{
  readonly id = 'umang-stub';
  readonly displayName = 'UMANG · multi-service';
  readonly displayNameHi = 'उमंग · बहु-सेवा';
  readonly dpdpCategory = 'identity-multi-government-service';
  readonly mode: ConnectorMode;

  constructor(mode: ConnectorMode = 'test') {
    this.mode = mode;
  }

  async getStatus(): Promise<UmangConnectorStatus> {
    return {
      id: this.id,
      mode: this.mode,
      connected: false,
      lastSyncAt: null,
      principalIdHash: null,
      servicesCount: SERVICES.length,
      notes: 'Discovery layer. Each service routes to its owning connector at v1.1.',
    };
  }

  async connect(): Promise<ConnectorResult<UmangConnectorStatus>> {
    return ok(await this.getStatus());
  }

  async disconnect(): Promise<void> {
    return;
  }

  async importPayload(): Promise<ConnectorResult<UmangSnapshot>> {
    return ok(this.mockPayload());
  }

  mockPayload(): UmangSnapshot {
    return { services: SERVICES, viewedAt: nowIso() };
  }
}

export function makeUmangStub(mode: ConnectorMode): UmangStubAdapter {
  return new UmangStubAdapter(mode);
}
